<template>
    <v-container fluid>
        <v-card :loading="loading">
                <v-card-title>
                    <v-text-field
                        v-model="buscarClientes"
                        append-icon="mdi-file-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headersClientes"
                    :items="clientes"
                    :search="buscarClientes"
                    :items-per-page="itemsPorPag"
                    :page="pagActual"
                    @pagination="updatePagination"
                >
                    <template v-slot:item.acciones="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="verCliente(item)"
                        >
                            mdi-file-document-edit-outline
                        </v-icon>
                    </template>
                </v-data-table>
        </v-card>
    </v-container>
</template>
<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import axios from "axios";
    export default {
        name: "Clientes",
        data() {
            return {
                headersClientes: [
                    {
                        text: 'Código Cliente',
                        align: 'start',
                        filterable: true,
                        sortable: true,
                        value: 'code'
                    },
                    {
                        text: 'Cliente',
                        align: 'start',
                        filterable: true,
                        sortable: true,
                        value: 'name'
                    },
                    {
                        text: '',
                        filterable: false,
                        sortable: false,
                        value: 'acciones'
                    }
                ],
                buscarClientes: '',
            };
        },
        methods: {
            ...mapActions(['setPaginacion']),
            async verCliente(cliente){
                this.$router.push(
                    {
                        name: 'cliente',
                        params: {
                            id: cliente.code
                        }
                    }
                ); 
            },
            updatePagination (pagination) {
                console.log(pagination);
                this.setPaginacion(pagination.page);
            },
        },
        async mounted(){
            console.log(this.pagActual);
            if (!this.clientes.length) {
                this.$store.dispatch("getClientesDisponibles", false);
            }
        },
        beforeDestroy(){
            //this.setPaginacion(1);
        },
        computed: {
            ...mapGetters({
                clientes: "clientesDisponibles",
                loading: "loadingClientes",
                pagActual: "pagActual",
                itemsPorPag: "itemsPorPag"
            })
        }
    }

</script>